import { render, staticRenderFns } from "./CoverDesignDialog.vue?vue&type=template&id=0f8770b5&scoped=true&"
import script from "./CoverDesignDialog.vue?vue&type=script&lang=js&"
export * from "./CoverDesignDialog.vue?vue&type=script&lang=js&"
import style0 from "./CoverDesignDialog.vue?vue&type=style&index=0&id=0f8770b5&scoped=true&lang=css&"
import style1 from "./CoverDesignDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8770b5",
  null
  
)

export default component.exports